import type { StructureFix } from '@peruselab/api-client/structureChecks';
import type { DrawingDocument } from '@peruselab/structure-editor/model';
import { setAtomFormalCharge, splitBondIntoIons } from '@peruselab/structure-editor/domain/graphDrawing';

/**
 * ADR 0020 D6 (#1101): a fix the server's check offered, applied to the drawing -- A sets the
 * element's usual charge, B clears the charge, C splits a metal bond into its ions. An unknown fix,
 * or one whose atoms are gone, changes nothing.
 */
export function applyStructureFix(document: DrawingDocument, fix: StructureFix): DrawingDocument {
  const atomId = fix.atomIds[0];
  switch (fix.kind) {
    case 'flip-sign': {
      const charge = Number(fix.args.charge);
      return atomId && Number.isInteger(charge) ? setAtomFormalCharge(document, atomId, charge) : document;
    }
    case 'clear-charge':
      return atomId ? setAtomFormalCharge(document, atomId, 0) : document;
    case 'split-into-ions':
      return fix.bondIds[0] ? splitBondIntoIons(document, fix.bondIds[0]) : document;
    default:
      return document;
  }
}
